import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 15px;

  input {
    width: 100%;
    margin-top: 15px;
    background: transparent;
    border-bottom: 1px dotted gray;
    line-height: 2;
  }
  .error {
    height: 13px;
    color: red;
    font-size: 12px;
  }

  @media (max-width: 480px) {
    margin-top: 5%;
  }
`;

const InputLabelAbove = ({
  id,
  type,
  value,
  label,
  error,
  name,
  onChange,
  ...props
}) => {
  const onTabDown = (e) => {
    const nextQuestion = props.allQuestions[props.index + 1];
    if (e.key === "Tab" && !nextQuestion) {
      e.preventDefault();
    }
  };

  return (
    <Wrapper id={id} tabIndex="-1">
      <label htmlFor={name}>{label}</label>
      <input
        onKeyDown={onTabDown}
        type={type}
        name={name}
        value={value || ""}
        {...props}
        onChange={onChange}
      />
      {error && <span className="error">{error.errorMessage}</span>}
    </Wrapper>
  );
};

export default InputLabelAbove;
